import { defineComponent, reactive } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "HomeView",
  setup() {
    const {
      t
    } = useI18n();
    const iconList = reactive([{
      id: "email",
      name: t("icon.email"),
      link: "mailto:yanan.wang.cs@gmail.com",
      class: "icon-email"
    }, {
      id: "github",
      name: t("icon.github"),
      link: "https://github.com/Yanan-Wang-cs",
      class: "icon-github2"
    }, {
      id: "cv",
      name: t("icon.cv"),
      link: "/doc/CV.pdf",
      class: "icon-gerenjianli"
    }, {
      id: "google",
      name: t("icon.google"),
      link: "https://scholar.google.com/citations?user=MkHlV1sAAAAJ&hl=en&oi=sra",
      class: "icon-Google"
    }]);
    const skillIcons = [{
      icon: "icon-shebeikaifa"
    }, {
      icon: "icon-bushu"
    }, {
      icon: "icon-zuzhijigou"
    }];
    const skillObject = reactive(skillIcons.map((item, index) => {
      return {
        ...item,
        title: t(`skills.list[${index}].title`),
        content: t(`skills.list[${index}].content`)
      };
    }));
    console.log(skillObject);
    return {
      iconList,
      skillObject
    };
  }
});